function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIconWrapper } from '../../components/atoms/Icon/withIconWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IconCheckCircle = function IconCheckCircle(props, ref) {
  return ___EmotionJSX("svg", _extends({
    width: "104",
    height: "103",
    viewBox: "0 0 104 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), ___EmotionJSX("path", {
    d: "M52 0.25C23.71 0.25 0.75 23.21 0.75 51.5C0.75 79.79 23.71 102.75 52 102.75C80.29 102.75 103.25 79.79 103.25 51.5C103.25 23.21 80.29 0.25 52 0.25ZM38.1113 73.4863L19.7125 55.0875C17.7138 53.0888 17.7138 49.86 19.7125 47.8613C21.7113 45.8625 24.94 45.8625 26.9388 47.8613L41.75 62.6213L77.01 27.3613C79.0088 25.3625 82.2375 25.3625 84.2363 27.3613C86.235 29.36 86.235 32.5888 84.2363 34.5875L45.3375 73.4863C43.39 75.485 40.11 75.485 38.1113 73.4863Z",
    fill: "#28C48F"
  }));
};

export default withIconWrapper( /*#__PURE__*/forwardRef(IconCheckCircle));
//# sourceMappingURL=IconCheckCircle.js.map